import { useAppSelector } from '@app/store/hooks';
import { ThemedView } from '@app/theme';
import { checkColor } from '@app/utils/utils';
import LottieView from 'lottie-react-native';
import { useEffect, useState } from 'react';
import { ActivityIndicator } from 'react-native';

const Loading  =()=>{
      const {isfromTDL} = useAppSelector(state => state.platformParams);
    
      return(
        <ThemedView flex={1} alignItems='center' justifyContent='center' backgroundColor="bg-surface-primary" >
        {
        isfromTDL ? 
        <LottieView
            source={require('../../../assets/lottie/tdl_loader.json')}
            style={{width: 273, height: 378}}
            autoPlay={true}
            loop={true}
        />
        :
        <ActivityIndicator size={12} color={checkColor("#1434CB")} />
        }
      </ThemedView>
      )
}

export default Loading;